import { check as checkFF } from '@webapp-next/lib/feature-flag';
import getVueEventBus from '@webapp-next/lib/vue-event-bus';
import HELP_EVENTS from '@webapp-next/modules/help-center/events';

// TODO: unify zE, zESettings and window.ZENDESK under window.APP.LIBS.ZENDESK
// for better visibility, add a confluence doc link on how it all works together

export async function loadZendeskWidget() {
  if (!window.__ZENDESK__) {
    return;
  }

  const { url } = window.__ZENDESK__;

  // Use the loginUser method for authentication
  zE('messenger', 'loginUser', function(callback) {
    fetch(url).then(res => {
      res.text().then(jwt => {
        callback(jwt);
      });
    });
  });

  _setupZendeskWatchers();
}

function _setupZendeskWatchers() {
  zE('messenger:on', 'unreadMessages', function(messages) {
    getVueEventBus().$emit(HELP_EVENTS.ZENDESK_MESSAGE_UPDATE, messages);
  });
  zE('messenger:on', 'close', function() {
    getVueEventBus().$emit(HELP_EVENTS.ZENDESK_MESSAGE_UPDATE, 0);
  });
}
